export default __webpack_public_path__ + "static/MRF-7251d93762b31545f459433d57e578f8.jpeg";